import React, { forwardRef, useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import FormItem from 'js/components/Form/FormItem'
import WidgetViewPortal from 'js/page/Widget/components/components//WidgetViewPortal'
import convertObjectToWidgetSettings from 'js/page/Widget/helpers/convertObjectToWidgetSettings'
import { WidgetSettingType } from 'js/page/Widget/types/WidgetType'

import ExternalSearch, { ExternalSearchSettings } from './ExternalSearch'

interface Props {
    guid: string
    settings: ExternalSearchSettings
    onSave: (settings: WidgetSettingType[]) => void
}

const ExternalSearchEdit = forwardRef(
    ({ guid, settings, onSave }: Props, ref) => {
        const { t } = useTranslation()

        useImperativeHandle(ref, () => ({
            onSave() {
                submitForm()
            },
        }))

        const { control, handleSubmit, watch } = useForm({
            defaultValues: settings,
        })
        const watchValues = watch()

        const filterValues = ({ title }) => {
            return convertObjectToWidgetSettings({
                title,
            })
        }

        const onSubmit = () => {
            onSave(filterValues(watchValues))
        }
        const submitForm = handleSubmit(onSubmit)

        return (
            <>
                <FormItem
                    control={control}
                    type="text"
                    name="title"
                    id={`title-${guid}`}
                    label={t('form.title')}
                    helper={t('form.title-helper-empty')}
                />

                <WidgetViewPortal
                    Component={ExternalSearch}
                    settings={filterValues(watchValues)}
                    guid={guid}
                />
            </>
        )
    },
)

ExternalSearchEdit.displayName = 'ExternalSearchEdit'

export default ExternalSearchEdit
